// apps/web/src/admin/reportWindow.ts
const DAY_MS = 24 * 60 * 60 * 1000;

/** ISO timestamp for the start of the trailing 30-day window. */
export function last30DaysStartIso(now: Date): string {
  return new Date(now.getTime() - 30 * DAY_MS).toISOString();
}

/** True when `iso` is within the trailing 30-day window from `now`. */
export function withinLast30Days(iso: string, now: Date): boolean {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return false;
  return t >= now.getTime() - 30 * DAY_MS;
}

/** Human-readable "Jul 23, 2026, 2:05 PM" for the PDF subtitle. */
export function reportTimestamp(now: Date): string {
  return now.toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
}
